function pauseOthers(self){
  var others = document.querySelectorAll(".wm-instructions-vids-video.playing video")
  for(var i = 0; i < others.length; i++){
    if(others[i] != self){
      others[i].pause()
      others[i].controls = false
      others[i].parentNode.classList.remove('playing')
    }
  }
}

function initInstructionVid(vid){
  let videl = vid.querySelector('video')
  vid.addEventListener('click',function(e){
    if(!vid.classList.contains('playing') && (videl.currentTime == 0 || videl.paused || videl.ended || videl.readyState <= 2)){
      e.preventDefault()
      pauseOthers(videl)
      vid.classList.add('playing')
      videl.play();
      videl.controls = true
      return false
    }
  })
  videl.addEventListener('play',function(e){
    pauseOthers(videl)
  })
}

let vids = document.querySelectorAll(".wm-instructions-vids-video")
for(let i = 0; i < vids.length; i++){
  initInstructionVid(vids[i])
}